module.exports = __webpack_public_path__ + "static/media/logo.d83ec260.png";